import { is, isNil, propOr } from 'ramda';
import { jwtDecode } from 'jwt-decode';

export const decodeJwtSafely = (token) => {
  if (!is(String, token) || !token) {
    return {};
  }

  try {
    const payload = jwtDecode(token);
    return !isNil(payload) && is(Object, payload) ? payload : {};
  } catch (error) {
    return {};
  }
};

export const isJwtExpired = (payload, nowInSeconds = Date.now() / 1000) => {
  const exp = propOr(null, 'exp', payload);
  return isNil(exp) || nowInSeconds > exp;
};
